import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div``

export default class Arrow extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="22"
          height="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M12.8520901 17.7744036C12.6694523 17.9526007 12.5280155 18 12.2967972 18h-.9909787c-.4147785 0-.5094796-.2897953-.230911-.5615907l7.8697185-7.678372H.7832403c-.2997842 0-.4612064-.1574974-.4612064-.4499925v-.6200896c0-.2924951.1614222-.4499925.4612064-.4499925H18.944626L11.0749075.5615907C10.7963389.2897953 10.89104 0 11.3061258 0h.9909787c.2312183 0 .3929478.0674989.5549851.2255964l8.669758 8.4589591c.208158.2030967.208158.4277932 0 .6308899l-8.669758 8.4589591 5e-7-9e-7z"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grades/Arrow.js